module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/am407-dc599f8a54e3b80ff06514919014058e.jpg";